import config from '../../utils/config';
import request from '../../utils/request';
import * as utils from '../../utils/utils';

// 新功能，关闭原有移动端英文版，改跳PC
// function redirectTheEnPageToPc() {
//     if (/en(\-stg)?\.ibuychem/.test(window.location.origin)) {

//     }
// }

// 移动端根据userAgent跳转PC
function jumpToPcByUserAgent() {
    const userAgentRegExp = /Android|webOS|iPhone|iPod|BlackBerry/i;
    if (!userAgentRegExp.test(navigator.userAgent) || /en(\-stg)?\.ibuychem/.test(window.location.origin)) {
        const pathname = window.location.pathname;
        const domain = window.location.origin;
        let url = domain;
        switch (pathname) {
            case '/m/':
                break;
            case '/m/offerlist/':
                url += `/offerlist`;
                break;
            case '/m/feature/':
                url += `/offerlist/special`;
                break;
            case '/m/zx/':
                url += `/zx`;
                break;
            case '/m/courses/':
                url += `/courses`;
                break;
            case '/m/experts/':
                url += `/experts`;
                break;
            case '/m/datasheet/':
                url += `/datesheet`;
                break;
            case '/m/classify/':
                url += `/offerlist`;
                break;
            case '/m/offer/':
                url += `/offer/${utils.GetQueryString('id')}`;
                break;
            case '/m/topone/':
                url += '/offerlist/treasure.html';
                break;
            case '/m/storeintro/':
                url += '/company/introduce.html';
                break;
            default:
                break;
        }
        window.location.href = url;
    }
}
jumpToPcByUserAgent();

const whiteList = ['404'];
let needCheckShopId = true;
whiteList.forEach((v: any, k: number) => {
    if ((window.location.origin + window.location.pathname).indexOf(v) !== -1) {
        needCheckShopId = false;
    }
});

(window as any).shopId = utils.checkShopId();
(window as any).env = '';

if (process.env.NODE_ENV === 'development') {
    (window as any).shopId = 'cx14yh1d9n';
    // (window as any).shopId = 'grace'; 
}
if (!(window as any).shopId && needCheckShopId) {
    window.location.href = '/m/404/';
}

// 买化塑统计
async function setLog() {
    const r = await request({
        url: `${config.PHPAPI}api/wshop/shop/info`,
        data: {
            shopDomain: (window as any).shopId
        }
    });

    if (r.error_code === 0) {
        (window as any).mhs_access.init({
            entityId: Object.keys(r.data)[0],
            entityType: "wshop",
            url: window.location.href
        });
    }
}

setLog();

async function intergralHandle(callback ? ) {
    // 如果是商品详情，获取id
    const href = window.location.href;

    const r: any = await utils.getShopInfo();
    let id = r.shop_id;

    let type = 'wshop_m';
    if (href.indexOf('/m/offer/') > -1) {
        id = utils.GetQueryString('id') || '';
        type = 'ws_goods';
    } else if (href.indexOf('/m/offerlist/') > -1) {
        type = 'wshop_m_offerlist';
    } else if (href.indexOf('/m/storeintro/') > -1) {
        type = 'wshop_m_storeintro';
    } else if (href.indexOf('/m/zx/') > -1) {
        type = 'wshop_m_zx';
    } else if (href.indexOf('/m/classify/') > -1) {
        type = 'wshop_m_classify';
    } else if (href.indexOf('/m/courses/') > -1) {
        type = 'wshop_m_courses';
    } else if (href.indexOf('/m/experts/') > -1) {
        type = 'wshop_m_experts';
    } else if (href.indexOf('/m/datasheet/') > -1) {
        type = 'wshop_m_datasheet';
    }

    (window as any).integral.sign({
        env: config.ENV === 'production' ? 'pro' : 'dev',
        code: '00_04_00_003',
        entityId: id,
        entityType: type,
        system: 3,
        callback
    });
}


// 微信分享
if ((window as any).WeChatShare) {
    let xhrData = '';
    if (process.env.NODE_ENV === 'development' || process.env.REACT_APP_PROJECT_ENV === 'test') {
        xhrData = `jsApiDomain=&url=${encodeURIComponent(window.location.href.split('#')[0])}`;
        (window as any).env = 'cn-stg';
    } else {
        xhrData = `jsApiDomain=&url=${encodeURIComponent(window.location.href.split('#')[0])}`;
        (window as any).env = 'cn';
    }

    (window as any).WeChatShare({
        async callback() {
            // 区分页面
            let shareInfoData = {
                shareType: 0,
                id: 0
            };

            if (window.location.origin.indexOf('.en') > -1) {
                switch (window.location.pathname) {
                    case '/m/':
                    case '/m/offerlist/':
                    case '/m/classify/':
                    case '/m/storeintro/':
                        shareInfoData.shareType = 10
                        break;
                    case '/m/offer/':
                        shareInfoData = {
                            shareType: 11,
                            id: utils.GetQueryString('id')
                        }
                        break;

                }
            } else {
                switch (window.location.pathname) {
                    case '/m/offer/':
                        shareInfoData = {
                            shareType: 2,
                            id: utils.GetQueryString('id')
                        }
                        break;
                    case '/m/':
                        shareInfoData.shareType = 1
                        break;
                    case '/m/offerlist/':
                        shareInfoData.shareType = 3
                        break;
                    case '/m/classify/':
                        shareInfoData.shareType = 4
                        break;
                    case '/m/courses/':
                        shareInfoData.shareType = 5
                        break;
                    case '/m/datasheet/':
                        shareInfoData.shareType = 7
                        break;
                    case '/m/experts/':
                        shareInfoData.shareType = 6
                        break;
                    case '/m/zx/':
                        shareInfoData.shareType = 8
                        break;
                    case '/m/storeintro/':
                        shareInfoData.shareType = 9
                        break;
                }
            }

            const r = await request({
                data: {
                    shopDomain: (window as any).shopId,
                    ...shareInfoData
                },
                method: 'post',
                url: `${config.PHPAPI}api/wshop/default/share-info2`
            });
            if (r.error_code === 0) {
                const [title, desc, imgUrl, link] = [
                    r.data.title,
                    r.data.description,
                    r.data.logo,
                    window.location.href
                ];
                (window as any).wx.onMenuShareAppMessage({
                    desc,
                    imgUrl,
                    link,
                    title,
                    success() {
                        intergralHandle();
                    }
                });
                (window as any).wx.onMenuShareTimeline({
                    desc,
                    imgUrl,
                    link,
                    title,
                    success() {
                        intergralHandle();
                    }
                });
                (window as any).wx.onMenuShareQQ({
                    desc,
                    imgUrl,
                    link,
                    title,
                    success() {
                        intergralHandle();
                    }
                });
                (window as any).wx.onMenuShareQZone({
                    desc,
                    imgUrl,
                    link,
                    title,
                    success() {
                        intergralHandle();
                    }
                });
            }
        },
        data: xhrData,
        url: config.CLASSAPI,
        sdkVersion: '1.6.0'
    });
}


// WEBPACK FOOTER //
// ./src/components/shop/common.tsx